import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';

import { RootState } from 'src/store';
import { isUnreadNotification } from 'src/utils/NotificationsUtils';

import { useAppSelector } from '../useStore';

const selectFilteredEsigNotifications = createSelector(
  (state: RootState) => state.notifications.esigRequestNotifications,
  (state: RootState) => state.activeCompany.activeCompanyId,
  (notifications, activeCompanyId) =>
    notifications.filter((notif) => notif.companyId === activeCompanyId),
);

export const useContractsNotificationCount = (): number => {
  const filteredNotifications = useAppSelector(selectFilteredEsigNotifications);

  return useMemo(() => {
    const unreadNotifications = filteredNotifications.filter((notif) =>
      isUnreadNotification(notif.ownerId),
    );
    return unreadNotifications.length;
  }, [filteredNotifications]);
};
